// extracted by mini-css-extract-plugin
module.exports = {"GlobalFooter":"GlobalFooter_GlobalFooter__107J0","StickyFooterPadding":"GlobalFooter_StickyFooterPadding__4DWPC"};